/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  CreateDepartmentDto,
  DataEnvelopeOfDepartmentDto,
  DataEnvelopeOfIEnumerableOfDepartmentTreeDto,
  DataEnvelopeOfObject,
  DataEnvelopeOfOrganizationRelationsDto,
  DataPaginationEnvelopeOfDepartmentDto,
  ErrorEnvelope,
  GetAllDepartmentsParams,
  UpdateDepartmentDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getDepartmentRelations = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfOrganizationRelationsDto>(
    { url: `/v1/departments/${id}/relations`, method: 'GET', signal },
    options,
  )
}

export const getGetDepartmentRelationsQueryKey = (id: string) => {
  return [`/v1/departments/${id}/relations`] as const
}

export const getGetDepartmentRelationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentRelations>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDepartmentRelationsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentRelations>>> = ({ signal }) =>
    getDepartmentRelations(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetDepartmentRelationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentRelations>>
>
export type GetDepartmentRelationsQueryError = unknown

export function useGetDepartmentRelations<
  TData = Awaited<ReturnType<typeof getDepartmentRelations>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentRelations>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentRelations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentRelations<
  TData = Awaited<ReturnType<typeof getDepartmentRelations>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentRelations>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentRelations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentRelations<
  TData = Awaited<ReturnType<typeof getDepartmentRelations>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDepartmentRelations<
  TData = Awaited<ReturnType<typeof getDepartmentRelations>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDepartmentRelations>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDepartmentRelationsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Lista todos os departamentos
 */
export const getAllDepartments = (
  params?: GetAllDepartmentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfDepartmentDto>(
    { url: `/v1/departments`, method: 'GET', params, signal },
    options,
  )
}

export const getGetAllDepartmentsQueryKey = (params?: GetAllDepartmentsParams) => {
  return [`/v1/departments`, ...(params ? [params] : [])] as const
}

export const getGetAllDepartmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllDepartments>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAllDepartmentsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDepartments>>> = ({ signal }) =>
    getAllDepartments(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllDepartments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllDepartmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllDepartments>>
>
export type GetAllDepartmentsQueryError = ErrorEnvelope

export function useGetAllDepartments<
  TData = Awaited<ReturnType<typeof getAllDepartments>>,
  TError = ErrorEnvelope,
>(
  params: undefined | GetAllDepartmentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDepartments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDepartments>>,
          TError,
          Awaited<ReturnType<typeof getAllDepartments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDepartments<
  TData = Awaited<ReturnType<typeof getAllDepartments>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDepartments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDepartments>>,
          TError,
          Awaited<ReturnType<typeof getAllDepartments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllDepartments<
  TData = Awaited<ReturnType<typeof getAllDepartments>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todos os departamentos
 */

export function useGetAllDepartments<
  TData = Awaited<ReturnType<typeof getAllDepartments>>,
  TError = ErrorEnvelope,
>(
  params?: GetAllDepartmentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDepartments>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllDepartmentsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Cria novo departamento (Admin/Manager)
 */
export const createDepartment = (
  createDepartmentDto: CreateDepartmentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfDepartmentDto>(
    {
      url: `/v1/departments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createDepartmentDto,
      signal,
    },
    options,
  )
}

export const getCreateDepartmentMutationKey = () => ['createDepartment'] as const

export const getCreateDepartmentMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDepartment>>,
    TError,
    CreateDepartmentMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDepartment>>,
  TError,
  CreateDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getCreateDepartmentMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDepartment>>,
    CreateDepartmentMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createDepartment(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDepartment>>
>
export type CreateDepartmentMutationBody = CreateDepartmentDto
export type CreateDepartmentMutationError = ErrorEnvelope
export type CreateDepartmentMutationVariables = { data: CreateDepartmentDto }

/**
 * @summary Cria novo departamento (Admin/Manager)
 */
export const useCreateDepartment = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDepartment>>,
      TError,
      CreateDepartmentMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDepartment>>,
  TError,
  CreateDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getCreateDepartmentMutationOptions(options), queryClient)
}
/**
 * @summary Retorna estrutura hierárquica de departamentos
 */
export const getDepartmentTree = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIEnumerableOfDepartmentTreeDto>(
    { url: `/v1/departments/tree`, method: 'GET', signal },
    options,
  )
}

export const getGetDepartmentTreeQueryKey = () => {
  return [`/v1/departments/tree`] as const
}

export const getGetDepartmentTreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentTree>>,
  TError = ErrorEnvelope,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentTree>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDepartmentTreeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentTree>>> = ({ signal }) =>
    getDepartmentTree(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepartmentTree>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentTreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentTree>>
>
export type GetDepartmentTreeQueryError = ErrorEnvelope

export function useGetDepartmentTree<
  TData = Awaited<ReturnType<typeof getDepartmentTree>>,
  TError = ErrorEnvelope,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentTree>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentTree>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentTree<
  TData = Awaited<ReturnType<typeof getDepartmentTree>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentTree>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentTree>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentTree<
  TData = Awaited<ReturnType<typeof getDepartmentTree>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentTree>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna estrutura hierárquica de departamentos
 */

export function useGetDepartmentTree<
  TData = Awaited<ReturnType<typeof getDepartmentTree>>,
  TError = ErrorEnvelope,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentTree>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDepartmentTreeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Obtém departamento por ID
 */
export const getDepartmentById = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfDepartmentDto>(
    { url: `/v1/departments/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetDepartmentByIdQueryKey = (id: string) => {
  return [`/v1/departments/${id}`] as const
}

export const getGetDepartmentByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepartmentById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDepartmentByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentById>>> = ({ signal }) =>
    getDepartmentById(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetDepartmentByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepartmentById>>
>
export type GetDepartmentByIdQueryError = ErrorEnvelope

export function useGetDepartmentById<
  TData = Awaited<ReturnType<typeof getDepartmentById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentById>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentById<
  TData = Awaited<ReturnType<typeof getDepartmentById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentById>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentById<
  TData = Awaited<ReturnType<typeof getDepartmentById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém departamento por ID
 */

export function useGetDepartmentById<
  TData = Awaited<ReturnType<typeof getDepartmentById>>,
  TError = ErrorEnvelope,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentById>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDepartmentByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza departamento (Admin/Manager)
 */
export const updateDepartment = (
  id: string,
  updateDepartmentDto: UpdateDepartmentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfDepartmentDto>(
    {
      url: `/v1/departments/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateDepartmentDto,
      signal,
    },
    options,
  )
}

export const getUpdateDepartmentMutationKey = () => ['updateDepartment'] as const

export const getUpdateDepartmentMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDepartment>>,
    TError,
    UpdateDepartmentMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDepartment>>,
  TError,
  UpdateDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateDepartmentMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDepartment>>,
    UpdateDepartmentMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return updateDepartment(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDepartment>>
>
export type UpdateDepartmentMutationBody = UpdateDepartmentDto
export type UpdateDepartmentMutationError = ErrorEnvelope
export type UpdateDepartmentMutationVariables = { id: string; data: UpdateDepartmentDto }

/**
 * @summary Atualiza departamento (Admin/Manager)
 */
export const useUpdateDepartment = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDepartment>>,
      TError,
      UpdateDepartmentMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDepartment>>,
  TError,
  UpdateDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getUpdateDepartmentMutationOptions(options), queryClient)
}
/**
 * @summary Remove departamento (Admin)
 */
export const deleteDepartment = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/departments/${id}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteDepartmentMutationKey = () => ['deleteDepartment'] as const

export const getDeleteDepartmentMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDepartment>>,
    TError,
    DeleteDepartmentMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDepartment>>,
  TError,
  DeleteDepartmentMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteDepartmentMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDepartment>>,
    DeleteDepartmentMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return deleteDepartment(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteDepartmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDepartment>>
>

export type DeleteDepartmentMutationError = ErrorEnvelope
export type DeleteDepartmentMutationVariables = { id: string }

/**
 * @summary Remove departamento (Admin)
 */
export const useDeleteDepartment = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDepartment>>,
      TError,
      DeleteDepartmentMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDepartment>>,
  TError,
  DeleteDepartmentMutationVariables,
  TContext
> => {
  return useMutation(getDeleteDepartmentMutationOptions(options), queryClient)
}
/**
 * @summary Ativa/desativa departamento (Admin/Manager)
 */
export const toggleDepartmentActive = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfDepartmentDto>(
    { url: `/v1/departments/${id}/toggle-active`, method: 'PATCH', signal },
    options,
  )
}

export const getToggleDepartmentActiveMutationKey = () => ['toggleDepartmentActive'] as const

export const getToggleDepartmentActiveMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleDepartmentActive>>,
    TError,
    ToggleDepartmentActiveMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleDepartmentActive>>,
  TError,
  ToggleDepartmentActiveMutationVariables,
  TContext
> => {
  const mutationKey = getToggleDepartmentActiveMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleDepartmentActive>>,
    ToggleDepartmentActiveMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return toggleDepartmentActive(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ToggleDepartmentActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleDepartmentActive>>
>

export type ToggleDepartmentActiveMutationError = ErrorEnvelope
export type ToggleDepartmentActiveMutationVariables = { id: string }

/**
 * @summary Ativa/desativa departamento (Admin/Manager)
 */
export const useToggleDepartmentActive = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleDepartmentActive>>,
      TError,
      ToggleDepartmentActiveMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleDepartmentActive>>,
  TError,
  ToggleDepartmentActiveMutationVariables,
  TContext
> => {
  return useMutation(getToggleDepartmentActiveMutationOptions(options), queryClient)
}
